import gql from 'graphql-tag'

export const newBook = gql`
  mutation newBook(
    $name: String!
    $author: String!
    $totalPages: Int
    $userId: ID!
  ) {
    createBook(
      name: $name
      author: $author
      totalPages: $totalPages
      userId: $userId
    ) {
      id
    }
  }
`

export const updateBook = gql`
  mutation updateBook(
    $name: String!
    $author: String!
    $totalPages: Int
    $id: ID!
    $userId: ID!
  ) {
    updateBook(
      name: $name
      author: $author
      totalPages: $totalPages
      id: $id
      userId: $userId
    ) {
      id
    }
  }
`

export const deleteBook = gql`
  mutation deleteBook($id: ID!) {
    deleteBook(id: $id) {
      id
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/mutations/book.js